<template>
  <div>
    <el-button
      type="primary"
      size="small"
      @click="handleEdit()"
      v-code="51301"
      v-if="admin"
    >
      添加入库单
    </el-button>
    <el-table :data="list">
      <el-table-column label="单号" align="center" prop="number">
      </el-table-column>
      <el-table-column label="业务类型" align="center" prop="business_type">
      </el-table-column>
      <el-table-column label="部门" align="center" prop="department">
      </el-table-column>
      <el-table-column label="业务员" align="center" prop="saler">
      </el-table-column>
      <el-table-column label="采购类型" align="center" prop="purchase_category">
      </el-table-column>
      <el-table-column label="供货单位" align="center" prop="supplier">
      </el-table-column>
      <!-- <el-table-column label="创建日期" align="center">
        <template slot-scope="scope">
          {{ $time(scope.row.created_at).format('YYYY-MM-DD HH:mm') }}
        </template>
      </el-table-column> -->
      <el-table-column label="入库日期" align="center" prop="stock_time">
        <template slot-scope="scope">
          {{
            scope.row.stock_time
              ? $time(scope.row.stock_time).format('YYYY-MM-DD')
              : '-'
          }}
        </template>
      </el-table-column>
      <!-- <el-table-column label="价税合计" align="center" prop="total_price">
        <template slot-scope="scope">
          {{ scope.row.status > 2 ? scope.row.total_price.toFixed(2) : '-' }}
        </template>
      </el-table-column> -->
      <el-table-column label="状态" align="center">
        <template slot-scope="scope">
          <el-tag size="mini" type="primary">{{
            PurchaseOrderStatusMap[scope.row.status]
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" min-width="120">
        <template slot-scope="scope">
          <el-popconfirm
            v-if="admin && scope.row.status == 1"
            v-code="51301"
            title="确认删除该入库单吗？"
            @confirm="handleDelete(scope.row.id, scope.$index)"
          >
            <el-link :underline="false" slot="reference" type="danger"
              >删除</el-link
            >
          </el-popconfirm>
          <el-link
            v-code="51301"
            :underline="false"
            v-if="admin && scope.row.status == 1"
            class="ml-10"
            type="primary"
            @click="handleEdit(scope.row, scope.$index)"
            >编辑</el-link
          >
          <el-link
            v-code="51301"
            :underline="false"
            class="ml-10"
            plain
            type="primary"
            @click="$router.push(`${$route.path}/${scope.row.id}`)"
            >详情</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <editor
      :model="model"
      :show.sync="formerVisible"
      @callback="callback"
    ></editor>
  </div>
</template>

<script>
import { purchaseOrderDelete } from '@/service/getData'
import { PurchaseOrderStatusMap } from '../../../config/global'
import editor from './editor'
export default {
  components: {
    editor,
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    category: {
      type: Number,
      default: 1,
    },
    admin: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      PurchaseOrderStatusMap,
      formerVisible: false,
      editIndex: -1,
      model: {},
    }
  },
  methods: {
    handleEdit(item, index) {
      if (!item) {
        this.editIndex = -1
        this.model = {
          business_type: '',
          purchase_category: '',
          department: '',
          saler: '',
          supplier: '',
          bookkeeper: '',
          belong_month: 1,
        }
      } else {
        this.model = this.clone(item)
        this.editIndex = index
      }
      this.formerVisible = true
    },
    async handleDelete(id, index) {
      let res = await purchaseOrderDelete(id)
      if (res.code == 0) {
        this.list.splice(index, 1)
      }
    },

    callback(data) {
      if (this.editIndex == -1) {
        this.list.unshift(data)
      } else {
        this.$set(this.list, this.editIndex, data)
      }
    },
  },
}
</script>